import React, {useContext} from 'react';
import {AppContext} from "../AppContext";
import {useNavigate} from "react-router-dom";

class LogoNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.setLogoElementLink();
    }

    setLogoElementLink() {
        if (!this.logoElementLink) {
            return;
        }
        if (!this.props.context?.visitor) {
            return;
        }
        this.logoElementLink.onclick = (e) => {
            e.preventDefault();
            this.props.navigate('/');
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.setLogoElementLink();
    }

    get logoElementLink() {
        return document.querySelector('header div.Logo-Navigation-Wrapper > a');
    }

    render() {
        return null;
    }
}

const LogoNavigationWithContext = (props) => {
    const navigate = useNavigate();
    const context = useContext(AppContext);
    return (<LogoNavigation {...props} context={context} navigate={navigate} />);
};

export default LogoNavigationWithContext;

